import { Api } from '@/services/Api';
import { Page } from '@/declarations/models/Page';
import { Status } from '@/declarations/models/Status';

/**
 * "Save and publish" for a page that is still `imported`.
 *
 * The backend lets a page leave `imported` only by placement - saved under a parent that is itself in the page tree
 * (ADR-0013) - and since 2026-10-14 a placement may publish in the same save. So this is one write: the page is
 * published at the root of the site's tree with the editor's content. Either it succeeds whole, or the page is still
 * imported and null is returned.
 */
export function publishImportedPage(page: Page, rootPageId: number): Promise<Page | null> {
  const toPublish: Page = { ...page, parent_id: rootPageId, status: Status.PUBLISHED };
  return Api.publishPageDraft(page.id!, page.active_version_id!, toPublish).fetchDirect(null);
}
